import { useSelector } from 'react-redux';

import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

export enum AnnualMilesVariant {
    MILES_PER_YEAR = 'milesPerYear',
    CUSTOM_MILEAGE = 'customMileage',
    CUSTOM_MILEAGE_NUMERIC = 'customMileageNumeric'
}

export const useAnnualMilesVariant = (): AnnualMilesVariant => {
    const isEnableCustomLeaseMileageByDealer = useSelector(featureToggleSelectors.getEnableCustomLeaseMileageByDealer);
    const isEnableCustomLeaseMileageByFeature = useSelector(featureToggleSelectors.getEnableCustomLeaseMileageByFeature);
    const isMileageOptionsUIUpdateEnabled = useSelector(featureToggleSelectors.isMileageOptionsUIUpdateEnabled);

    if (!(isEnableCustomLeaseMileageByDealer && isEnableCustomLeaseMileageByFeature)) {
        return AnnualMilesVariant.MILES_PER_YEAR;
    }
    return isMileageOptionsUIUpdateEnabled ? AnnualMilesVariant.CUSTOM_MILEAGE_NUMERIC : AnnualMilesVariant.CUSTOM_MILEAGE;
};
